<template>
  <div class="flipbook_modal">
    <GenericModal
      unique-id="flipbookModal"
      ref="flipbookModal"
      :has-header="true"
      :has-footer="false"
      :max-width="'100%'"
      :max-height="'100%'"
      :close-btn-color="'#ef1b1b'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      :modal-close-off="true"
      background-blur="none"
      border-radius="0px"
      @modal-closed="navigateToProduct"
    >
      <template v-slot:header>
        <div class="flipbook_modal-header">
          <div class="flipbook_modal-header-title">
            <span class="flipbook_modal-title">{{ bookTitle }}</span>
            <div v-show="bookAuthors.length > 0" class="flipbook_modal-authors">
              <span v-for="(author, index) in bookAuthors.slice(0, 2)" :key="author.id" class="flipbook_modal-author">
              {{ author.translations.el.name }}<span v-if="index < bookAuthors.length - 1">, </span>
            </span>
            </div>
          </div>
          <slot name="add-to-cart" />
        </div>
      </template>
      <div class="iframe-container">
        <iframe :src="flipbookUrl"
                loading="lazy"
                frameborder="0"
                style="border:none;
                overflow:hidden"
                allowTransparency="true"
                allow="encrypted-media"
                allowfullscreen
                width="100%"
                height="100%"
        ></iframe>
      </div>
    </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'

export default {
  name: 'FlipbookModal',
  components: {
    GenericModal
  },
  props: {
    flipbookUrl: {
      type: String,
      required: true
    },
    bookTitle: {
      type: String,
      required: true
    },
    bookAuthors: {
      type: Array,
      required: false
    }
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    if (this.flipbookUrl && urlParams.has('flipbook') && urlParams.get('flipbook') === 'open') {
      this.openModal()
    }
  },
  methods: {
    openModal () {
      this.$refs.flipbookModal.$emit('modal-open')
    },
    navigateToProduct () {
      window.location.href = window.location.href.split('?')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cp-utilities-generic_modal-body {
  display: contents;
  justify-items: center;
}
::v-deep .cp-utilities-generic_modal {
  grid-template-rows: auto 1fr;
  padding: 0!important;
}
.iframe-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  background: #f7f7f7;
}
iframe {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
}
.flipbook_modal-header {
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.flipbook_modal-header-title {
  display: grid;
  gap: 5px;
  padding: 5px 15px;
}
.flipbook_modal-title {
  color: #231F20;
  font-size: 20px;
}
.flipbook_modal-author {
  font-size: 17px;
  color: #8d7197;
  height: 30px;
}
.flipbook_modal-authors {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  height: 30px;
}
</style>
